import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Package, PlusSquare, Handshake, User } from 'lucide-react';
import { useState, useEffect } from 'react';
import api from '@/lib/api';

const navItems = [
  { path: '/', icon: Home, label: 'Feed', isPublic: true },
  { path: '/locker', icon: Package, label: 'Locker', isPublic: false },
  { path: '/upload', icon: PlusSquare, label: 'Subir', isPublic: false },
  { path: '/deals', icon: Handshake, label: 'Tratos', isPublic: false },
  { path: '/profile', icon: User, label: 'Perfil', isPublic: false },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const check = () => api.get('/notifications/count').then(r => setUnreadCount(r.data.count)).catch(() => {});
    check();
    const interval = setInterval(check, 15000);
    return () => clearInterval(interval);
  }, []);

  const handleNav = (path) => {
    navigate(path);
  };

  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 z-50 bg-zinc-950/90 backdrop-blur-xl border-t border-zinc-800/60 lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      <div className="h-16 max-w-lg mx-auto grid grid-cols-5 items-center px-1">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = location.pathname === path || (path === '/' && location.pathname.startsWith('/item'));
          const isUpload = path === '/upload';
          const isDeals = path === '/deals';
          return (
            <button key={path} data-testid={`nav-${label.toLowerCase()}`} onClick={() => handleNav(path)}
              className={`flex flex-col items-center justify-center gap-0.5 relative min-h-[48px] transition-all active:scale-95 ${
                isUpload ? 'text-primary-foreground' : isActive ? 'text-primary' : 'text-zinc-500 hover:text-zinc-300'}`}>
              {isUpload ? (
                <span className="bg-primary w-12 h-12 rounded-2xl flex items-center justify-center -mt-4 shadow-lg shadow-primary/30"><Icon className="w-6 h-6" /></span>
              ) : (
                <><Icon className={`w-5 h-5 transition-all ${isActive ? 'scale-110' : ''}`} /><span className={`text-[10px] font-body leading-none ${isActive ? 'font-semibold' : 'font-medium'}`}>{label}</span></>
              )}
              {isDeals && unreadCount > 0 && (
                <span className="absolute top-1 right-1/4 bg-red-500 text-white text-[9px] min-w-[16px] h-4 flex items-center justify-center font-bold rounded-full animate-pulse-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
